import { useMemo } from 'modules/core/hooks/useMemo'

import {
  EmailValidation as FnEmailValidation,
  validateEmailForCreation,
} from '../lib/validateEmailForCreation'
import { UserData, useDebouncedFetchUser } from './useDebouncedFetchUser'

export type EmailValidation = FnEmailValidation & {
  existingUser?: UserData
}

export const useValidateEmailForCreation = (email: string): EmailValidation => {
  const { user: existingUser } = useDebouncedFetchUser(email)
  const emailValidation = useMemo(() => validateEmailForCreation(email), [email])

  return { ...emailValidation, existingUser: existingUser }
}
